interface ProjectKpiCardProps {
  label: string;
  value: string | number;
  icon: string;
  iconColor: string;
  iconBg: string;
  sublabel?: string;
}

export default function ProjectKpiCard({ label, value, icon, iconColor, iconBg, sublabel }: ProjectKpiCardProps) {
  return (
    <div className="bg-white rounded-card border border-background-200 p-4 hover:border-background-300 transition-colors">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-xs text-foreground-500 font-medium mb-1">{label}</p>
          <p className="text-lg font-bold text-foreground-900 font-heading tabular-nums">
            {typeof value === "number" ? value.toLocaleString("pt-BR") : value}
          </p>
          {sublabel && <p className="text-xs text-foreground-400 mt-0.5">{sublabel}</p>}
        </div>
        <div className={`w-9 h-9 rounded-lg ${iconBg} flex items-center justify-center shrink-0`}>
          <i className={`${icon} ${iconColor} text-sm`}></i>
        </div>
      </div>
    </div>
  );
}